import React from 'react';
import axios from 'axios';
import Row from './Row';

class BuoyOverview extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      loading: props.loading !== undefined ? props.loading : true,
      error: props.error !== undefined ? props.error : false,
      message: props.message !== undefined ? props.message : null,
      url: props.url,
      data: {}
    };
  
  }

  componentDidMount() {
    const url = process.env.REACT_APP_API_URL + '/waves/list';
    axios.get(url, {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      crossdomain: true,
    })
    .then(res => {
      this.setState({ loading: false, data: res.data });
    })
    .catch(error => {
      console.log("error loading data: " + error);
      this.setState({ loading: false, error: true, message: error.message });
    });
  }

  // Force reload of this component.
  reload(event) {
    this.setState({ loading: true });
    this.componentDidMount();
  }

  toggleHistory(event) {
    console.log("toggle history!");
  }

  render(data) {
    console.log('rendering component for state: loading=' + this.state.loading + ', error=' + this.state.error);
    if (this.state.loading) {
      return <div>Loading</div>;
    } else if (this.state.error) {
      return <div className="error">ERROR: {this.state.message}</div>;
    } else {
      const rows = this.state.data.map((row, i) =>
        <Row key={i} data={row} />);
      return (
        <div className="BuoyOverview">
          {/* <button className="reload" type="button" onClick={ this.reload.bind(this) }>
            <span>Data Vernieuwen</span>
          </button> */}
          <table className="overview">
            <thead>
              <tr>
                <th scope="col">Lokatie</th>
                <th scope="col">Deining Richting</th>
                <th scope="col">Deining Hoogte</th>
                <th scope="col" className="toggleHistory"></th>
                <th scope="col">Windgolven Richting</th>
                <th scope="col">Windgolven Hoogte</th>
                <th scope="col" className="toggleHistory"></th>
              </tr>
            </thead>
            {rows}
          </table>
        </div>);
    }
  }

}

export default BuoyOverview



// WEBPACK FOOTER //
// ./src/Components/BuoyOverview.jsx